<template>
  <b-container>
    <div class="reciep-footer reciep-body py-1 mx-auto">
      <b-img
        class="bg-logo"
        center
        fluid
        src="@/assets/images/logo/SoulPay_Tag_Neg.png"
      />
      <h5 class="subtitle text-center mt-1 mb-2 ">
        Via do Cliente
      </h5>

      <slot />
    </div>
  </b-container>
</template>

<script>
import {
  BContainer, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BContainer,
    BImg,
  },
}

</script>

<style lang="scss" scoped>
  @import "@core/scss/vue/apps/reciep.scss";

  .help-button {
    padding: 0;
    background-color: transparent !important;
    border: none;
  }
</style>
